import type { ComponentChildren, HTMLAttributes, JSX } from "preact";
import { classNames } from "@gss/common/classNames";
import { BadgeLength } from "./BadgeLength";
import "./Table.css";

interface TableProps extends HTMLAttributes<HTMLTableElement> {
    bodyProps?: HTMLAttributes<HTMLTableSectionElement>;
    className?: string;
    hover?: boolean;
    small?: boolean;
    striped?: boolean;
    bordered?: boolean;
    darkHeaders?: boolean;
    headers?: ComponentChildren;
}

export function Table({
    className,
    hover,
    small,
    striped,
    bordered,
    darkHeaders,
    headers,
    children,
    bodyProps,
    ...rest
}: TableProps): JSX.Element {
    return (
        <table
            {...rest}
            className={classNames(
                "table",
                striped && "table-striped",
                small && "table-sm",
                bordered && "table-bordered",
                hover && "table-hover table-hover-row",
                className,
            )}
        >
            {headers != null && (
                <thead className={classNames(darkHeaders && "table-dark")}>
                    {headers}
                </thead>
            )}
            {children != null && <tbody {...bodyProps}>{children}</tbody>}
        </table>
    );
}

interface HeaderProps {
    list?: unknown[];
    className?: string;
    children: ComponentChildren;
}

export function TableHeader({
    list,
    className,
    children,
}: HeaderProps): JSX.Element {
    return (
        <h3 className={className}>
            {children}
            {list != null && (
                <small>
                    &nbsp;
                    <BadgeLength>{list}</BadgeLength>
                </small>
            )}
        </h3>
    );
}
